import {createSvgIcon} from './utils'

export const UserRoundFillIcon = createSvgIcon(
  <path
    clipRule="evenodd"
    d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM5.62002 16.8273C6.59596 15.4935 8.72364 15 12 15C15.2764 15 17.404 15.4935 18.38 16.8273C16.9192 18.7549 14.605 20 12 20C9.39497 20 7.08076 18.7549 5.62002 16.8273ZM12 13.5C13.8 13.5 15.5 11.5 15.5 9C15.5 5.8 13.35 5 12 5C10.65 5 8.5 5.8 8.5 9C8.5 11.64 10.2 13.5 12 13.5Z"
    fill="#21201F"
    fillRule="evenodd"
  />,
  'UserRoundFill',
)
